import { IOdooSession } from "@juleb/browser";

export enum AppActions {
  SET_ODOO_SESSION = "SET_ODOO_SESSION",
}

export interface ISetOdooSession {
  type: AppActions.SET_ODOO_SESSION;
  session: IOdooSession;
}

export function setOdooSession(session: IOdooSession): ISetOdooSession {
  return {
    type: AppActions.SET_ODOO_SESSION,
    session,
  };
}

export type AppAction = ISetOdooSession;
